//
//
//
//
//

import { generateComputed } from '../../common/functions/roles-computed-generator';

export default {
  name: 'CarteiraCliente',
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create('Acesso negado', 'snack', 3E3);
    },
  },
  computed: {
    ...generateComputed('Carteira', [
      'canAccessPage',
    ]),
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/carteira-cliente/CarteiraCliente.vue?vue&type=script&lang=js&